import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import OrgSwitcher from '../tenant/OrgSwitcher';
import { useTenantContext } from '../../contexts/TenantContext';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const { tenantInfo } = useTenantContext();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { label: 'Início', path: '/' },
    { label: 'Apresentação', path: '/apresentacao' },
    { label: 'Agentes', path: '/agentes' },
    { label: 'Sobre', path: '/sobre' },
    { label: 'Contato', path: '/contato' },
  ];

  const isActive = (path: string) => location.pathname === path;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled
        ? 'bg-white shadow-lg py-3'
        : 'bg-white/95 backdrop-blur-sm shadow-md py-5'
        }`}
    >
      <div className="container">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center space-x-3">
            <div className="w-12 h-12 bg-[var(--tenant-primary,#1E88E5)] text-white rounded-lg flex items-center justify-center shadow-sm">
              <span className="font-bold text-xl">IC</span>
            </div>
            <div>
              <h1 className="text-2xl font-bold" style={{ color: 'var(--tenant-primary, #1E88E5)' }}>
                {tenantInfo?.name || 'IntelliCare'}
              </h1>
              <p className="text-xs text-neutral-600">
                Agentes Inteligentes em Saúde
              </p>
            </div>
          </Link>

          <nav className="hidden lg:flex items-center space-x-8">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`font-medium transition-colors duration-200 ${isActive(item.path)
                  ? 'text-primary-600 font-semibold'
                  : 'text-neutral-700 hover:text-primary-600'
                  }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>

          <div className="hidden lg:flex items-center space-x-4">
            <OrgSwitcher />
            <Link
              to="/solicitacao"
              className="px-4 py-2 border-2 border-primary-600 text-primary-600 font-semibold rounded-lg hover:bg-primary-600 hover:text-white transition-all duration-200"
            >
              Solicitar Participação
            </Link>
          </div>

          <button
            className="lg:hidden p-2 rounded-lg hover:bg-neutral-100 transition-colors"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? (
              <X className="w-6 h-6 text-neutral-700" />
            ) : (
              <Menu className="w-6 h-6 text-neutral-700" />
            )}
          </button>
        </div>

        {isMobileMenuOpen && (
          <nav className="lg:hidden bg-white border-t border-neutral-200 mt-4">
            <div className="px-4 py-4 space-y-2">
              {navItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={() => setIsMobileMenuOpen(false)}
                  className={`block px-4 py-2 rounded-lg transition-colors ${isActive(item.path)
                    ? 'bg-primary-50 text-primary-600'
                    : 'text-neutral-700 hover:bg-neutral-50'
                    }`}
                >
                  {item.label}
                </Link>
              ))}
              <Link
                to="/solicitacao"
                onClick={() => setIsMobileMenuOpen(false)}
                className="block w-full px-4 py-2 bg-primary-600 text-white font-semibold rounded-lg text-center hover:bg-primary-700 transition-colors"
              >
                Solicitar Participação
              </Link>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
